// extracted by mini-css-extract-plugin
module.exports = {"buttons":"ConfirmModal_buttons__2EPlh","alertIcon":"ConfirmModal_alertIcon___gd66"};